module.exports = __webpack_public_path__ + "static/img/christmas_bg_new.0e80348.png";